import { useMemo } from 'react';

import { pickFlow } from '@eduzz-registry-360/validators';

import { DocumentNotFoundFlow } from '@/components/flows/DocumentNotFound';
import { Error } from '@/components/flows/Error';
import { LegalEntityPartner } from '@/components/flows/LegalEntityPartner';
import { LegalEntityRelationFlow } from '@/components/flows/LegalEntityRelationFlow';
import { LegalEntityRepresentative } from '@/components/flows/LegalEntityRepresentative';
import { Loading } from '@/components/flows/Loading';
import { NaturalPerson } from '@/components/flows/NaturalPerson';
import { Pending } from '@/components/flows/Pending';
import { TheEnd } from '@/components/flows/TheEnd';
import Header from '@/components/globals/Header';
import { RegistryBootstrap } from '@/components/globals/RegistryBootstrap';
import { Wizard } from '@/components/Wizard';
import useAuthStore from '@/stores/auth';

const WizardContent = () => {
  const currentUser = useAuthStore(({ currentUser }) => currentUser);

  const isApp = useMemo(() => {
    const url = new URL(window.location.href);
    return url.searchParams.get('app') !== null;
  }, []);

  if (!currentUser) {
    return null;
  }

  const flow = pickFlow(currentUser.document);

  return (
    <>
      {!isApp && <Header />}

      <Wizard defaultSelected={flow}>
        <Wizard.FlowList name='document-not-found'>
          <DocumentNotFoundFlow />
        </Wizard.FlowList>

        <Wizard.FlowList name='natural-person'>
          <NaturalPerson />
          <TheEnd />
        </Wizard.FlowList>

        <Wizard.FlowList name='legal-entity'>
          <LegalEntityRelationFlow />
        </Wizard.FlowList>

        <Wizard.FlowList name='legal-entity-partner-validated'>
          <LegalEntityPartner />
          <TheEnd />
        </Wizard.FlowList>

        <Wizard.FlowList name='legal-entity-representative'>
          <LegalEntityRepresentative />
          <Pending />
        </Wizard.FlowList>

        <Wizard.FlowList name='loading'>
          <Loading />
        </Wizard.FlowList>

        <Wizard.FlowList name='error'>
          <Error />
        </Wizard.FlowList>

        <Wizard.FlowList name='pending'>
          <Pending />
        </Wizard.FlowList>
      </Wizard>
    </>
  );
};

const WizardPage = () => (
  <RegistryBootstrap>
    <WizardContent />
  </RegistryBootstrap>
);

export default WizardPage;
